import React, { useState } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import GestioneLib from './GestioneLib';

function LabInventoryPage() {
    const [activeTab, setActiveTab] = useState(0);

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
    };

    return (
        <Box sx={{ width: '100%', mt: 2 }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs
                    value={activeTab}
                    onChange={handleTabChange}
                    aria-label="lab inventory tabs"
                    sx={{
                        '& .MuiTab-root': {
                            fontFamily: "'PT Sans Narrow', Arial, sans-serif",
                            fontWeight: 600,
                            fontSize: '16px',
                            textTransform: 'none',
                            color: '#666',
                            '&.Mui-selected': {
                                color: '#a71e3b',
                            },
                        },
                        '& .MuiTabs-indicator': {
                            backgroundColor: '#a71e3b',
                        },
                    }}
                >
                    <Tab label="Inventario LIB (Laboratori Fisici)" />
                </Tabs>
            </Box>
            <Box sx={{ py: 3 }}>
                {activeTab === 0 && <GestioneLib />}
            </Box>
        </Box>
    );
}

export default LabInventoryPage;
